import { Box, Button } from '@factorialco/deprecated-design-system'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import i18n from 'modules/core/lib/i18n'

interface PaymentExecutionActionsProps {
  onRevoke?: () => void
}

export const Actions = ({ onRevoke }: PaymentExecutionActionsProps) => {
  return (
    <Box gap="s4" flexDirection="row" justifyContent="flexEnd">
      <PopoverMenu type="list">
        <PopoverMenu.Trigger>
          <Button.Decorative type="secondary" iconName="ellipsis" />
        </PopoverMenu.Trigger>
        <PopoverMenu.Content side="bottom" align="start">
          <PopoverMenu.TouchableOption
            title={i18n.t('banking.transfers.actions.remove_transfer')}
            onClick={onRevoke}
          />
        </PopoverMenu.Content>
      </PopoverMenu>
    </Box>
  )
}
